import { captureMessage } from '../../../Services/Sentry';

// Counts down the server's remaining seconds. Comparing a server timestamp
// against the device clock falsely expires devices on the wrong timezone.
export const deadlineFrom = (response) => {
    if (Number.isFinite(response?.expiresIn)) {
        return new Date(Date.now() + (response.expiresIn * 1000));
    }

    const parsed = response?.expiresAt ? new Date(response.expiresAt) : null;

    return parsed?.getTime() > Date.now() ? parsed : null;
};

export const reportClockSkew = (response, tags) => {
    if (!Number.isFinite(response?.expiresIn) || !response?.expiresAt) {
        return;
    }

    const serverNow = new Date(response.expiresAt).getTime() - (response.expiresIn * 1000);

    if (!Number.isFinite(serverNow)) {
        return;
    }

    const skew = Math.round((Date.now() - serverNow) / 1000);

    if (Math.abs(skew) < 120) {
        return;
    }

    captureMessage('Login device clock is out of sync with the server', {
        level: 'warning',
        tags,
        extra: {
            skewSeconds: skew,
            deviceTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            deviceOffsetMinutes: new Date().getTimezoneOffset(),
        },
    });
};
